import { FC } from 'react';
import { Card } from '@synqo/frontend-component-library';

interface PlaceholdersProps {
    placeholders: string[];
}

export const Placeholders: FC<PlaceholdersProps> = ({ placeholders }) => {
    if (placeholders.length == 0) {
        return undefined;
    }

    return (
        <Card name="placeholders" label={'Platzhalter'} collapsable={false} fullyRounded border="withBorder">
            {placeholders.map((placeholder) => (
                <p key={placeholder}>{placeholder}</p>
            ))}
        </Card>
    );
};
